
const PrivacyPolicy = () => {
  return (
    <main>

      <section className="articles">

        <article>
          <div className="privacy-policy">
            <h3>Privacy Policy</h3>
            <p>
              No personal data is collected by myself or the ad provider in any games published under the name "Jonah Heywood"
            </p>
          </div>
        </article>

      </section>

    </main>
  );
}

export default PrivacyPolicy;